export const treatmentCheckoutStorageKey = (token) => `welliemd_treatment_checkout:${token}`;
export const legacyTreatmentCheckoutStorageKey = (token) => `welliemd_phase2_checkout:${token}`;

export const clearTreatmentCheckout = (token) => {
  sessionStorage.removeItem(treatmentCheckoutStorageKey(token));
  sessionStorage.removeItem(legacyTreatmentCheckoutStorageKey(token));
};

export const persistRepricedCheckout = (checkout, previousToken) => {
  let token = previousToken;
  let route;
  if (checkout.checkout_url) {
    const url = new URL(checkout.checkout_url, window.location.origin);
    const match = url.pathname.match(/^\/checkout\/([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})\/?$/i);
    if (url.origin !== window.location.origin || url.username || url.password || !match) {
      throw new Error("Your updated checkout link could not be opened. Please reload your checkout.");
    }
    token = match[1];
    route = `/checkout/${token}?flow=combined`;
  }
  // A changed selection can replace an unpaid submission and its bearer link.
  // Persist first, then move the browser to the same canonical recovery token.
  sessionStorage.setItem(treatmentCheckoutStorageKey(token), JSON.stringify(checkout));
  if (route) window.history.replaceState(window.history.state, "", route);
  if (token !== previousToken) clearTreatmentCheckout(previousToken);
  return token;
};
